<script>
	import userService from '../../user/service.svelte.js';
    import { locale } from 'svelte-i18n';

    let languages = $derived(userService.getLangOptions($locale));

    const setLocale = (element) => {
		let code = element.target.value;
        if(code != $locale){
            locale.set(code);
		    /*userService.saveLoggedUserSettings({key: "lang", value: code}, [], {no_toaster: true})
			    .catch(e=>false)
                .then(() => true)
            ;*/
			userService.patchOwnUSer({language: code})
				.then(user => {
					return true;
				})
				.catch(errors => {
					return false;
				})
			;
        }

    }
  </script>

  <div class="text-center">
	{#key $locale}
		<select class="form-control" oninput={(e) => setLocale(e)} style="padding: 0.2rem 0.75rem !important;">
			{#each languages as { code, name }}
      			<option value="{code}" selected={code == $locale}>{name}</option>
    		{/each}
		</select>
	{/key}
  </div>
